import {
  DEFAULT_RECORDING_MODE,
  RECORDING_MODE_LIVE_MODE,
} from '../config/constants';
import { RecordingMode } from '../config/types';

import { getStoredPreferences } from './getStoredPreferences';
import { savePreferencesToStorage } from './savePreferencesToStorage';

// The choice is stored as the live mode it records with.
export const getStoredOrganizationRecordingMode = (
  organizationId: string,
): RecordingMode => {
  const stored =
    getStoredPreferences().treatmentModeByOrganization?.[organizationId];
  if (!stored) {
    return DEFAULT_RECORDING_MODE;
  }
  return stored === RECORDING_MODE_LIVE_MODE.visit ? 'visit' : 'dictation';
};

export const saveOrganizationRecordingMode = (
  organizationId: string,
  mode: RecordingMode,
) => {
  const preferences = getStoredPreferences();
  savePreferencesToStorage({
    ...preferences,
    treatmentModeByOrganization: {
      ...preferences.treatmentModeByOrganization,
      [organizationId]: RECORDING_MODE_LIVE_MODE[mode],
    },
  });
};
